import React from 'react';
import type { FC } from 'react';
import { I18nProvider, Trans } from '@wix/cli-i18n';
import { Text, Notification } from '@wix/cli-ui-kit';
import messages from '../messages.json' with { type: 'json' };

interface PackageDetails {
  currentVersion: string;
  latestVersion?: string;
  deprecated?: string;
  hasCliAppInstalled: boolean;
}

export const OutdatedVersionMessage: FC<PackageDetails> = ({
  currentVersion,
  latestVersion,
  deprecated,
  hasCliAppInstalled,
}) => {
  return (
    <I18nProvider messages={messages}>
      <Notification>
        {deprecated && (
          <Trans
            i18nKey="version_notifier.deprecated.message"
            components={[<Text skin="secondary" />, <Text bold />]}
            values={{
              currentVersion,
            }}
          />
        )}
        <Trans
          i18nKey="version_notifier.update.message"
          components={[<Text skin="secondary" />, <Text skin="success" />]}
          values={{
            currentVersion,
            latestVersion,
          }}
        />
        <Trans
          i18nKey="version_notifier.update.instructions"
          components={[<Text skin="info" />]}
          values={{
            packages: hasCliAppInstalled
              ? 'npm i @wix/cli@latest @wix/cli-app@latest'
              : 'npm i -g @wix/cli@latest',
          }}
        />
      </Notification>
    </I18nProvider>
  );
};
